/* jshint esversion: 6 */
/* jshint ignore:start */
import { useContext, useRef, useState } from 'react';
import PhoneInput, { formatPhoneNumberIntl } from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { MyContext } from '../Context/MyProvider';
import { showToast } from '../showTost';
import axios from 'axios';
import Callicon from '../assets/Icon/call.svg';
import Lockicon from '../assets/Icon/lock.svg';
import Eyeicon from '../assets/Icon/eye.svg';
import Eyeslashicon from '../assets/Icon/eye-slash.svg';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Emailicon from '../assets/Icon/email.svg';
import secureLocalStorage from "react-secure-storage";

const Login = () => {

    const { t } = useTranslation();
    const { setIsLoginShow, setIsSignUpShow, ApiBaseUrl, setIsLogin } = useContext(MyContext);

    const [value, setValue] = useState();
    const [password, setPassword] = useState("");
    const [email, setEmail] = useState("");
    const [passType, setPassType] = useState("password");
    const [passType2, setPassType2] = useState("password");
    const [passType3, setPassType3] = useState("password");
    const [isPageShow, setIsPageShow] = useState("Login");
    const [otpContext, setOtpContext] = useState("login");
    const [forgot, setForgot] = useState("");
    const [otpBox, setOtpBox] = useState(Array(6).fill(''));
    const [sendOtp, setSendOtp] = useState("");
    const [newPassword, setNewPassword] = useState({ password: "", confirm: "" });
    const [apiloading, setApiLoading] = useState(false);
    const [selecttype, setSelectType] = useState("Phone");

    const InputRef = useRef();
    const OtpRef = useRef(Array.from({ length: 6 }, () => null));

    const Navigate = useNavigate();

    const getPhoneParts = (phoneValue) => {
        const formattedNumber = formatPhoneNumberIntl(phoneValue);
        if (!formattedNumber) return null;
        const countryCode = formattedNumber.split(' ')[0];
        const numberWithoutCode = formattedNumber.replace(countryCode, '').trim();
        const cleanedNumber = numberWithoutCode.split(' ').join('');
        return { ccode: countryCode, phone: cleanedNumber };
    };

    const completeLogin = (customer_detail, message, payload = {}) => {
        showToast({ title: message, id: "success" });
        Navigate("/");
        secureLocalStorage.setItem("Loginuser", JSON.stringify(customer_detail));
        secureLocalStorage.setItem("Userid", customer_detail.id);
        if (payload.v1_tokens?.access_token) {
            secureLocalStorage.setItem("v1_access_token", payload.v1_tokens.access_token);
        }
        if (payload.socket_token) {
            secureLocalStorage.setItem("socket_token", payload.socket_token);
        }
        setIsLogin("123");
        setIsLoginShow(false);
    };

    const handleEmailLogin = () => {
        if (apiloading) return;

        if (!email) {
            showToast({ title: t("Please enter email"), id: "warning" });
            return;
        }

        if (!password) {
            showToast({ title: t("Please enter password"), id: "warning" });
            return;
        }

        setApiLoading(true);

        axios.post(`${ApiBaseUrl}/customer/login`, {
            ulogin_data: email,
            c_code: "",
            password
        })
            .then(response => {
                const { ResponseCode, message, customer_detail } = response.data;
                if (ResponseCode === 200) {
                    completeLogin(customer_detail, message, response.data);
                } else {
                    showToast({ title: message, id: "error" });
                }
                setApiLoading(false);
            })
            .catch(err => {
                console.error("Login Error:", err);
                showToast({ title: t("Login failed. Please try again."), id: "error" });
                setApiLoading(false);
            });
    };

    const handleSendLoginOtp = () => {
        if (apiloading) return;

        if (!value) {
            showToast({ title: t("Please enter number"), id: "warning" });
            return;
        }

        const parts = getPhoneParts(value);
        if (!parts) {
            showToast({ title: t("Please enter a valid phone number"), id: "warning" });
            return;
        }

        setApiLoading(true);

        axios.post(`${ApiBaseUrl}/customer/mobile_check`, { ...parts, mode: 'login' })
            .then((res) => {
                const { ResponseCode, message, Result } = res.data;
                if (ResponseCode === 200 && Result) {
                    sendOtpRequest(parts, 'login');
                } else {
                    showToast({ title: message || t("Mobile Number Not Found!"), id: "error" });
                    setApiLoading(false);
                }
            })
            .catch((error) => {
                console.error("mobile_check", error);
                setApiLoading(false);
                showToast({ title: t("Login failed. Please try again."), id: "error" });
            });
    };

    const sendOtpRequest = (parts, context) => {
        axios.post(`${ApiBaseUrl}/customer/msg91`, parts)
            .then((res) => {
                const { ResponseCode, message, otp } = res.data;
                if (ResponseCode === 200) {
                    setApiLoading(false);
                    showToast({ title: message, id: "success" });
                    setOtpContext(context);
                    setOtpBox(Array(6).fill(''));
                    setSendOtp(otp);
                    setIsPageShow("OTP");
                } else {
                    setApiLoading(false);
                    showToast({ title: message, id: "error" });
                }
            })
            .catch(() => {
                setApiLoading(false);
                showToast({ title: t("Login failed. Please try again."), id: "error" });
            });
    };

    const HandleChange = (index, val) => {
        const OTP = [...otpBox];
        OTP[index] = val;
        setOtpBox(OTP);
        if (val && !isNaN(val) && index < OtpRef.current.length - 1) {
            OtpRef.current[index + 1].focus();
        }
    };

    const HandleKeyPress = (index, e) => {
        if (e.key === "Backspace" && index > 0 && !e.target.value) {
            OtpRef.current[index - 1].focus();
        }
    };

    const HandleContinueForgot = () => {
        if (apiloading) return;

        if (!forgot) {
            showToast({ title: t("Please enter number"), id: "warning" });
            return;
        }

        const parts = getPhoneParts(forgot);
        if (!parts) {
            showToast({ title: t("Please enter a valid phone number"), id: "warning" });
            return;
        }

        setApiLoading(true);

        axios.post(`${ApiBaseUrl}/customer/mobile_check`, { ...parts, mode: 'forgot' })
            .then((res) => {
                const { ResponseCode, message, Result } = res.data;
                if (ResponseCode === 200 && Result) {
                    sendOtpRequest(parts, 'forgot');
                } else {
                    showToast({ title: message || t("Mobile Number Not Found!"), id: "error" });
                    setApiLoading(false);
                }
            })
            .catch((error) => {
                console.error("mobile_check", error);
                setApiLoading(false);
            });
    };

    const HandleVerifyOTP = () => {
        if (sendOtp !== otpBox.join("")) {
            showToast({ title: t("OTP is invalid !!"), id: "error" });
            return;
        }

        if (otpContext === 'forgot') {
            setIsPageShow("NewPass");
            return;
        }

        const phoneValue = value;
        const parts = getPhoneParts(phoneValue);
        if (!parts) {
            showToast({ title: t("Please enter a valid phone number"), id: "warning" });
            return;
        }

        setApiLoading(true);

        axios.post(`${ApiBaseUrl}/customer/login_otp`, parts)
            .then((res) => {
                const { ResponseCode, message, customer_detail } = res.data;
                if (ResponseCode === 200) {
                    completeLogin(customer_detail, message, res.data);
                } else {
                    showToast({ title: message, id: "error" });
                }
                setApiLoading(false);
            })
            .catch((error) => {
                console.error("login_otp", error);
                showToast({ title: t("Login failed. Please try again."), id: "error" });
                setApiLoading(false);
            });
    };

    const HandleResetPass = () => {
        if (apiloading) return;

        if (!newPassword.password || !newPassword.confirm) {
            showToast({ title: t("Enter Password !!"), id: "error" });
            return;
        }

        if (newPassword.password !== newPassword.confirm) {
            showToast({ title: t("Not Match Password !!"), id: "error" });
            return;
        }

        const parts = getPhoneParts(forgot);
        if (!parts) {
            showToast({ title: t("Please enter a valid phone number"), id: "warning" });
            return;
        }

        setApiLoading(true);

        axios.post(`${ApiBaseUrl}/customer/forgot_password`, {
            ...parts,
            password: newPassword.confirm
        })
            .then((res) => {
                setApiLoading(false);
                const Id = res.data.ResponseCode === 200 ? "success" : "error";
                showToast({ title: res.data.message, id: Id });
                if (res.data.ResponseCode === 200) setIsLoginShow(false);
            })
            .catch((error) => {
                console.error("forgot_password", error);
                setApiLoading(false);
            });
    };

    const otpPhoneLabel = otpContext === 'forgot' ? forgot : value;

    return (
        <div>

            {isPageShow === "Login" && <div className="py-[10px] px-[20px] login-box">
                <h1 className='text-[22px] font-bold'>Sign in to Doctor</h1>
                <span className="text-gray-500 text-[16px] font-[500]">Welcome back. Please enter your details.</span>

                <div className="border-[1px] inline-block rounded-[50px] p-[5px] mt-[5px]">
                    <div className="flex items-center gap-[5px]">
                        <button onClick={() => setSelectType("Phone")} className={`w-[100px] duration-[0.5s] ${selecttype === "Phone" && "bg-[#0d9488] text-white"} py-[4px] rounded-[50px] font-[500] text-[15px]`} >Phone</button>
                        <button onClick={() => setSelectType("Email")} className={`w-[100px] duration-[0.5s] ${selecttype === "Email" && "bg-[#0d9488] text-white"} py-[4px] rounded-[50px] font-[500] text-[15px]`} >Email</button>
                    </div>
                </div>

                {selecttype === "Phone"
                    ? <>
                        <div className="relative gap-[5px] login-input focus-within:border-[#0d9488] mt-[10px] focus-within:border-[1px]">
                            <img src={Callicon} alt="Call Icon" className="w-[25px]" />
                            <PhoneInput
                                className="w-[100%]"
                                ref={InputRef}
                                international
                                defaultCountry="IN"
                                value={value}
                                onChange={setValue}
                                name="phone"
                                style={{ outline: "none" }}
                            />
                            {!value && <h1 onClick={() => InputRef.current.focus()} className='absolute top-[10px] left-[4.75rem] text-gray-500 text-sm pointer-events-none'>Phone Number</h1>}
                        </div>
                        <p className="text-gray-500 text-[14px] mt-[12px]">{t("Enter the OTP sent to your phone")}</p>
                        <button onClick={handleSendLoginOtp} className="bg-[#0d9488] w-[100%] py-[8px] text-white font-bold rounded-[10px] mt-[20px]">
                            {apiloading
                                ? <div className="loader mx-auto"></div>
                                : <span>{t("Send OTP")}</span>}
                        </button>
                    </>
                    : <>
                        <div className="login-input focus-within:border-[#0d9488] mt-[10px] focus-within:border-[1px]">
                            <img src={Emailicon} alt="EmailIcon" className="w-[25px]" />
                            <input onChange={(e) => setEmail(e.target.value)} type="email" placeholder='Email' className='w-[100%] bg-transparent outline-none px-[10px]' />
                        </div>
                        <div className="login-input focus-within:border-[#0d9488] mt-[20px] focus-within:border-[1px]">
                            <img src={Lockicon} alt="Lockicon" className="w-[25px]" />
                            <input onChange={(e) => setPassword(e.target.value)} className="bg-transparent px-[10px] w-[100%] outline-none" type={passType} placeholder="Password" />
                            <img onClick={() => setPassType(passType === "text" ? "password" : "text")} src={passType === "text" ? Eyeicon : Eyeslashicon} alt="LockIcon " className="w-[20px] cursor-pointer" />
                        </div>
                        <button onClick={() => setIsPageShow("Forgot")} className='font-[500] mt-[10px] '>Forgot password? <span className='text-[#0d9488]'>Reset it</span></button>
                        <button onClick={handleEmailLogin} className="bg-[#0d9488] w-[100%] py-[8px] text-white font-bold rounded-[10px] mt-[20px]">
                            {apiloading
                                ? <div className="loader mx-auto"></div>
                                : <span>Sign In</span>}
                        </button>
                    </>}

                <h1 className="mt-[10px] text-center font-[500]">Don't have an account? <button onClick={() => { setIsLoginShow(false); setIsSignUpShow(true); }} className="text-[#0d9488] cursor-pointer">Sign Up</button> </h1>
            </div>}

            {isPageShow === "Forgot" && <div className="py-[10px] px-[20px]">
                <h1 className='text-center text-[24px] font-[500]'>Can't Sign in?</h1>
                <p className='text-center text-gray-500 text-[18px] leading-[25px]'>Enter the mobile number associated with your account, and we will send you an OTP to reset your password.</p>
                <div className="relative login-input focus-within:border-[#0d9488] mt-[20px] focus-within:border-[1px]">
                    <img src={Callicon} alt="Call Icon" className="w-[25px]" />
                    <PhoneInput
                        className="w-[100%]"
                        ref={InputRef}
                        international
                        defaultCountry="IN"
                        value={forgot}
                        onChange={setForgot}
                        name="phone"
                        style={{ outline: "none" }}
                    />
                    {!forgot && <h1 onClick={() => InputRef.current.focus()} className='absolute top-[10px] left-[4.75rem] text-gray-500 text-sm pointer-events-none'>Phone Number</h1>}
                </div>

                <button onClick={HandleContinueForgot} className='w-[100%] bg-[#0d9488] font-[500] py-[8px] mt-[25px] text-white rounded-[10px]'>
                    {apiloading
                        ? <div className="loader mx-auto"></div>
                        : <span>{t("Send OTP")}</span>}
                </button>
                <button onClick={() => setIsPageShow("Login")} className="w-[100%] border-[1px] border-[#0d9488] font-[500] py-[8px] mt-[10px] text-[#0d9488] rounded-[10px]">Return to Sign In</button>
            </div>}

            {isPageShow === "OTP" && <div className="py-[10px] px-[20px] signup-box">
                <h1 className='font-[500] text-[20px] text-center'>Verify OTP</h1>
                <p className='text-center text-gray-500 text-[15px] mt-[8px]'>{t("Enter the OTP sent to your phone")} <span className='text-black font-[500]'>{otpPhoneLabel}</span></p>
                <div className="otp-row">
                    {otpBox.map((val, index) => {
                        return <input
                            ref={(e) => (OtpRef.current[index] = e)}
                            key={index}
                            value={val}
                            className='otp-box'
                            type="text"
                            maxLength="1"
                            inputMode="numeric"
                            autoComplete="one-time-code"
                            onKeyDown={(e) => HandleKeyPress(index, e)}
                            onChange={(e) => HandleChange(index, e.target.value.replace(/\D/g, '').slice(0, 1))}
                        />
                    })}
                </div>
                <button onClick={HandleVerifyOTP} className='w-[100%] bg-[#0d9488] font-[500] py-[8px] mt-[25px] text-white rounded-[10px]'>
                    {apiloading
                        ? <div className="loader mx-auto"></div>
                        : <span>VERIFY OTP</span>}
                </button>
                <button onClick={() => setIsPageShow(otpContext === 'forgot' ? "Forgot" : "Login")} className="w-[100%] border-[1px] border-[#0d9488] font-[500] py-[8px] mt-[10px] text-[#0d9488] rounded-[10px]">Back</button>
            </div>}

            {isPageShow === "NewPass" && <div className="py-[10px] px-[20px]">
                <h1 className='font-[500] text-[18px] text-center'>Create A New Password</h1>
                <div className="login-input focus-within:border-[#0d9488] mt-[20px] focus-within:border-[1px]">
                    <img src={Lockicon} alt="userIcon" className="w-[25px]" />
                    <input onChange={(e) => setNewPassword({ ...newPassword, password: e.target.value })} type={passType2} placeholder='Password' className='w-[100%] bg-transparent outline-none px-[10px]' />
                    <img onClick={() => setPassType2(passType2 === "text" ? "password" : "text")} src={passType2 === "text" ? Eyeicon : Eyeslashicon} alt="LockIcon " className="w-[20px] cursor-pointer" />
                </div>
                <div className="login-input focus-within:border-[#0d9488] mt-[20px] focus-within:border-[1px]">
                    <img src={Lockicon} alt="userIcon" className="w-[25px]" />
                    <input onChange={(e) => setNewPassword({ ...newPassword, confirm: e.target.value })} type={passType3} placeholder='Confirm Password' className='w-[100%] bg-transparent outline-none px-[10px]' />
                    <img onClick={() => setPassType3(passType3 === "text" ? "password" : "text")} src={passType3 === "text" ? Eyeicon : Eyeslashicon} alt="LockIcon " className="w-[20px] cursor-pointer" />
                </div>

                <button onClick={HandleResetPass} className='w-[100%] bg-[#0d9488] font-[500] py-[8px] mt-[25px] text-white rounded-[10px]'>
                    {apiloading
                        ? <div className="loader mx-auto"></div>
                        : <span>Continue</span>}
                </button>

            </div>}

        </div>
    )
}

export default Login
/* jshint ignore:end */
